import React from 'react';
import JobCard  from "./JobCard";
import Job from './Job';
const JobSection = ({ jobs, title, icon, color, emptyMessage }) => {
    return (
<div className="card mb-4 border-0 shadow-none" style={{background:"transparent", marginTop:"40px"}}>
      <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
        <h4 className="mb-0" style={{ fontWeight: "600", color }}>
          <i className={`bi ${icon} me-2`}></i>{title}
        </h4>
        <span className={`badge bg-${color === "#4CAF50" ? "success" : "primary"} rounded-pill`}>
          {jobs.length}
        </span>
      </div>
      <div className="card-body">
        {jobs.length === 0 ? (
          <div className="text-center py-4">
            <i className="bi bi-check-circle-fill text-muted" style={{ fontSize: "2rem" }}></i>
            <p className="mt-2 text-muted">{emptyMessage}</p>
          </div>
        ) : (
          <div className="row g-4">
            {jobs.map((job, i) => (
              <div key={i} className="col-md-12">
                <JobCard
                  batch={job} 
                  isActive={color === "#4CAF50"} 
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
    );
};

export default JobSection;